// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import CheckOutlinedSvg from "@ant-design/icons-svg/lib/asn/CheckOutlined";
import AntdIcon from "../components/AntdIcon";
const CheckOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: CheckOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    CheckOutlined.displayName = "CheckOutlined";
}
export default /*#__PURE__*/ React.forwardRef(CheckOutlined);
